import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "imagesFluid": "caracteristica4.jpg",
  "title": "Servico 4"
};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const FeatureLayout = makeShortcode("FeatureLayout");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <FeatureLayout width={'33%'} featureImageFluid={props.imagesFluid['caracteristica4.png']} mdxType="FeatureLayout">
 <h2>Transporte de cargas expressas</h2>
      <p>{`Transporte de cargas expressas temos entregas constantes entre São Paulo e Nordeste. Nas modalidades:fracionadas e dedicada.`}</p>
    </FeatureLayout>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      